import { render, staticRenderFns } from "./GFEnrollmentList.vue?vue&type=template&id=1df24c70"
import script from "./GFEnrollmentList.vue?vue&type=script&lang=js"
export * from "./GFEnrollmentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports